import { createContext } from 'react';

const InitialState = {
  domainsList: {},
  emailsList: [],
  selectedDomain: null,
  defaultDomain: '',
  domainsListIsLoading: true,
  emailsListIsLoading: true,
};

const actionTypes = {
  SET_DOMAINS_LIST: 'SET_DOMAINS_LIST',
  SET_EMAILS_LIST: 'SET_EMAILS_LIST',
  REMOVE_DOMAIN: 'REMOVE_DOMAIN',
  SELECT_DOMAIN: 'SELECT_DOMAIN',
  SET_DOMAINS_LIST_IS_LOADING: 'SET_DOMAINS_LIST_IS_LOADING',
  SET_EMAILS_LIST_IS_LOADING: 'SET_EMAILS_LIST_IS_LOADING',
};

const EmailContext = createContext(InitialState);

export { EmailContext };
export { InitialState };
export { actionTypes };
